import { authorizationHookFactory } from "./hooks/(beforeRequest)/auth";
import { base } from "./base";
import { errorToastHook } from "./hooks/(beforeError)/errorToast";
import { loaderEndHook } from "./hooks/(afterResponse)/loaderEnd";
import { loaderErrorHook } from "./hooks/(beforeError)/loaderError";
import { loaderStartHook } from "./hooks/(beforeRequest)/loaderStart";
import { refreshAuthTokenHook } from "./hooks/(afterResponse)/refreshAuthToken";

const authorizationHook = authorizationHookFactory(() => localStorage.getItem("token"));

// Authenticated — loader + auth + 403 refresh
export const httpAuth = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, refreshAuthTokenHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, authorizationHook],
  },
});
